import { render, staticRenderFns } from "./medicaments.html?vue&type=template&id=3ac32b12&scoped=true&external"
import script from "./medicaments.js?vue&type=script&lang=js&external"
export * from "./medicaments.js?vue&type=script&lang=js&external"
import style0 from "./medicaments.scss?vue&type=style&index=0&id=3ac32b12&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac32b12",
  null
  
)

export default component.exports